<template>
	<v-snackbar v-if="snackbar" v-model="snackbar.active" :timeout="snackbar.timeout" location="top" absolute>
		<span v-html="snackbar.message"></span>

		<template #actions>
			<v-btn
				v-if="snackbar.type === 'action'"
				color="success"
				:width="snackbar.action?.width ?? 64"
				:loading="actionLoading"
				@click="action"
			>
				{{ snackbar.action.text }}
			</v-btn>
			<v-btn v-if="snackbar.timeout > 0" icon="mdi-close-circle" density="comfortable" @click="hideSnackbar" />
		</template>
	</v-snackbar>
</template>

<script>
export default {
	name: "SnackbarNotification",

	data() {
		return {
			actionLoading: false
		};
	},

	computed: {
		snackbar() {
			return this.$store.getters.snackbarNotification();
		}
	},

	watch: {
		"snackbar.active"(active) {
			if (active) {
				this.actionLoading = false;
			}
		}
	},

	methods: {
		hideSnackbar() {
			this.$store.commit("HIDE_NOTIFICATION", this.snackbar);
		},

		action() {
			this.actionLoading = true;
			this.snackbar.action.click(() => {
				this.actionLoading = false;
				this.hideSnackbar(this.snackbar);
			});
		}
	}
};
</script>
